import { render } from "./AssignmentsBar.vue?vue&type=template&id=e4d9f0be&scoped=true"
import script from "./AssignmentsBar.vue?vue&type=script&lang=js"
export * from "./AssignmentsBar.vue?vue&type=script&lang=js"

import "./AssignmentsBar.vue?vue&type=style&index=0&id=e4d9f0be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4d9f0be"]])

export default __exports__